import { combineReducers } from 'redux';

import LinksManagementSetLinkStatusEnum from '../../../enumerations/LinksManagementSetLinkStatusEnum';
import complaintWithdrawnReasons from './complaintWithdrawnReasons';
import enforcementDisruptedReasons from './enforcementDisruptedReasons';
import links from './links';
import * as fromRelaunchEnforcement from './links/relaunchEnforcement';
import searchEngine from './searchEngine';

export default combineReducers({
  complaintWithdrawnReasons,
  enforcementDisruptedReasons,
  links,
  searchEngine,
});

const getCountProcessedLinks = (links, status) => {
  const linkByStatus = links.filter(link => status.includes(link.status.name));
  return linkByStatus.length;
};

export const getLinksManagementLinksDetectionLinkUrlsIntroduced = state =>
  state.tasks.linksManagement.links.values.detectionLinkUrls;

export const getLinksManagementLinksContentLinkUrlsIntroduced = state =>
  state.tasks.linksManagement.links.values.contentLinkUrls;

export const getLinksManagementLinksProcessingDetectionLinks = state =>
  state.tasks.linksManagement.links.processingValues.detectionLinks;

export const getLinksManagementLinksProcessingContentLinks = state =>
  state.tasks.linksManagement.links.processingValues.contentLinks;

export const getLinksManagementLinksProcessingStatus = state =>
  state.tasks.linksManagement.links.processingValues.newStatus;

export const getLinksManagementEnforcementSelectedReason = state =>
  state.tasks.linksManagement.links.processingValues.selectedReason;

export const getLinksManagementRelaunchEnforcementSuccessfulLinksCount = state =>
  fromRelaunchEnforcement.getLinksManagementRelaunchEnforcementSuccessfulLinksCount(
    state.tasks.linksManagement.links.relaunchEnforcement
  );

export const getLinksManagementRelaunchEnforcementErrorLinksCount = state =>
  fromRelaunchEnforcement.getLinksManagementRelaunchEnforcementErrorLinksCount(
    state.tasks.linksManagement.links.relaunchEnforcement
  );

export const getLinksManagementRelaunchEnforcementErrors = state =>
  fromRelaunchEnforcement.getLinksManagementRelaunchEnforcementErrors(
    state.tasks.linksManagement.links.relaunchEnforcement
  );

export const getAreContentLinksProcessed = state => {
  const links = getLinksManagementLinksProcessingContentLinks(state);
  return getAreLinksProcessed(links);
};

export const getAreDetectionLinksProcessed = state => {
  const links = getLinksManagementLinksProcessingDetectionLinks(state);
  return getAreLinksProcessed(links);
};

const getAreLinksProcessed = links => {
  let processingLink = false;

  if (links && links.length) {
    processingLink = !links.find(({ status }) =>
      [
        LinksManagementSetLinkStatusEnum.WAITING,
        LinksManagementSetLinkStatusEnum.PROCESSING,
      ].includes(status)
    );
  }

  return processingLink;
};

export const getAreDetectionLinksBeingProcessed = state => {
  const links = getLinksManagementLinksProcessingDetectionLinks(state);
  return links.length > 0;
};

export const getAreContentLinksBeingProcessed = state => {
  const links = getLinksManagementLinksProcessingContentLinks(state);
  return links.length > 0;
};

export const getLinksManagementLinksProcessedDetectionLinks = state => {
  const links = getLinksManagementLinksProcessingDetectionLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.SUCCESS.name,
    LinksManagementSetLinkStatusEnum.ERROR.name,
  ]);
};

export const getLinksManagementLinksProcessedContentLinks = state => {
  const links = getLinksManagementLinksProcessingContentLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.SUCCESS.name,
    LinksManagementSetLinkStatusEnum.ERROR.name,
  ]);
};

export const getLinksManagementLinksProcessedDetectionLinksFailured = state => {
  const links = getLinksManagementLinksProcessingDetectionLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.ERROR.name,
  ]);
};

export const getLinksManagementLinksProcessedDetectionLinksSuccessfully = state => {
  const links = getLinksManagementLinksProcessingDetectionLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.SUCCESS.name,
  ]);
};

export const getLinksManagementLinksProcessedContentLinksFailured = state => {
  const links = getLinksManagementLinksProcessingContentLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.ERROR.name,
  ]);
};

export const getLinksManagementLinksProcessedContentLinksSuccessfully = state => {
  const links = getLinksManagementLinksProcessingContentLinks(state);
  return getCountProcessedLinks(links, [
    LinksManagementSetLinkStatusEnum.SUCCESS.name,
  ]);
};

export const getLinksManagementEnforcementDisruptedReasonsListIsLoading = state =>
  state.tasks.linksManagement.enforcementDisruptedReasons.isLoading;

export const getLinksManagementEnforcementDisruptedReasonsList = state =>
  state.tasks.linksManagement.enforcementDisruptedReasons.response.data;

export const getLinksManagementComplaintWithdrawnReasonsListIsLoading = state =>
  state.tasks.linksManagement.complaintWithdrawnReasons.isLoading;

export const getLinksManagementComplaintWithdrawnReasonsList = state =>
  state.tasks.linksManagement.complaintWithdrawnReasons.response.data;

export const getLinksManagementSearchEngineListIsLoading = state =>
  state.tasks.linksManagement.searchEngine.isLoading;

export const getLinksManagementSearchEngineList = state =>
  state.tasks.linksManagement.searchEngine.response.data;
